import { createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'

const pageSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/page`,
        initialState: 1,
        reducers: {
            changePage: (state, action) => action.payload,
            resetPage: () => 1,
        },
    })

export const pageActions = (prefix: PrefixType) => pageSlice(prefix).actions

const page = (prefix: PrefixType) => pageSlice(prefix).reducer

export default page
